import { ERegisterStatus, ESendSmsStatus, EConfirmPhoneStatus } from '../../types/registration';
export var defaultState = {
  register: {
    status: ERegisterStatus.Initial
  },
  sendSms: {
    status: ESendSmsStatus.Initial
  },
  confirmPhone: {
    status: EConfirmPhoneStatus.Initial
  },
  isProfessionalUser: false
};